import { User } from 'firebase/auth';
import * as ReactFirebaseHooksAuth from 'react-firebase-hooks/auth';

import { auth, getUserOrganisationsRoles } from '../firebase';
import { UserOrganisationsRoles } from '../interfaces';
import { createContext, useContext, useEffect, useState } from 'react';

interface AuthContextType {
  user: User | null | undefined;
  loading: boolean;
  userRoles: UserOrganisationsRoles;
  refresh: () => void;
}
const initialState: AuthContextType = {
  user: null,
  loading: false,
  refresh: () => {},
  userRoles: {
    isSuperAdmin: false,
    adminIn: [],
    memberIn: []
  }
};
const AuthContext = createContext<AuthContextType>(initialState);

const AuthState = ({ children }: { children: any }) => {
  const [user, loading] = ReactFirebaseHooksAuth.useAuthState(auth);
  const [reload, setReload] = useState<boolean>(false);
  const [userRoles, setUserRoles] = useState<UserOrganisationsRoles>(initialState.userRoles);
  const refresh = () => setReload(!reload);
  useEffect(() => {
    if (!user || loading) {
      console.log('no user or loading');
      return;
    }
    (async () => {
      try {
        const _userRoles = await getUserOrganisationsRoles(user);
        setUserRoles(_userRoles);
      } catch (e) {
        console.log('getting userRoles failed:', e);
      }
    })();
  }, [user, loading, reload]);

  return <AuthContext.Provider value={{ user, loading, userRoles, refresh }}>{children}</AuthContext.Provider>;
};
export default AuthState;
export const useAuthState = () => useContext(AuthContext);
